import React from 'react'

const AssignTasksSubcategory: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2244_11410)" />
    <path
      d="M35 19C39.1765 19 42.5294 22.2941 42.5294 26.4118C42.5294 30.4118 39 33.8824 34.9412 33.8824C30.8824 33.8824 27.4706 30.4118 27.4706 26.3529C27.4118 22.2353 30.7059 19 35 19Z"
      fill="white"
    />
    <path
      d="M42.2353 44.5883C42.2353 42.8236 42.7647 41.2354 43.6471 39.8236C41.0588 37.8236 37.7647 36.706 34.2353 36.8236C27.7647 37.1766 22.2353 42.0001 21.0588 48.4119C20.7647 50.2354 21.4118 51.0001 23.2941 51.0001C27.1765 51.0001 31 51.0001 34.9412 51.0001C38.3529 51.0001 41.7647 51.0001 45.1765 51.0001C43.3529 49.5295 42.2353 47.1766 42.2353 44.5883Z"
      fill="white"
    />
    <path
      d="M52.1764 35.2942C52.7058 35.2942 53.1764 35.706 53.1764 36.2942C53.1764 36.8236 52.7647 37.2942 52.1764 37.2942H51.7058V38.353C52.8823 38.5295 53.8823 39.0001 54.7647 39.706L55.4117 39.0589C55.8235 38.6471 56.4117 38.6471 56.8235 39.0589C57.2353 39.4707 57.2353 40.0589 56.8235 40.4707L56.0588 41.2354C56.7058 42.2354 57.0588 43.4118 57.0588 44.706C57.0588 48.2354 54.1764 51.0589 50.7058 51.0589C47.2353 51.0589 44.3529 48.1765 44.3529 44.706C44.3529 41.5295 46.7058 38.8824 49.7647 38.4118V37.353H49.2353C48.7058 37.353 48.2353 36.9412 48.2353 36.353C48.2353 35.8236 48.647 35.353 49.2353 35.353H52.1764V35.2942ZM51.4706 41.1765C51.4706 40.7648 51.1176 40.4118 50.7058 40.4118C50.2941 40.4118 49.9411 40.7648 49.9411 41.1765V45.1177C49.9411 45.5295 50.2941 45.8824 50.7058 45.8824C51.1176 45.8824 51.4706 45.5295 51.4706 45.1177V41.1765Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2244_11410"
        x1="5"
        y1="4.84619"
        x2="65.5"
        y2="66.3462"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0090AA" />
        <stop offset="1" stopColor="#00768B" />
      </linearGradient>
    </defs>
  </svg>
)

export default AssignTasksSubcategory
